import { Card, CardHeader, Title1, makeStyles } from '@fluentui/react-components';
import React from 'react';
import { Line } from 'react-chartjs-2';
import QueueBoard from '../parts/dashboard/QueueBoard';
import ArchivePerDay from '../parts/dashboard/ArchivePerDay';

const useStyles = makeStyles({
    card: {
        width: "30%",
    },
    board: {
        display: "flex",
        columnCount: "4",
        marginTop: "20px",
        marginBottom: "10px",
    },
    divide: {
        display: "block"
    },

})

const Dashboard = () => {
    const styles = useStyles();;

    return (
        <>
            <Title1>CosmeWidget Dashboard</Title1>

            <div className={styles.board}>

                <QueueBoard className={styles.card} />
            </div>


            <div className={styles.board}>
                <ArchivePerDay className={styles.card} />

                {/* <LineChartBoard
                    title='日毎抽出数'
                ></LineChartBoard> */}
                <Card className={styles.card}>
                    <CardHeader
                        header="日毎抽出数">
                        <Line
                            data={
                                {
                                    labels: [],
                                    datasets: [{
                                        label: '抽出数',
                                        fill: true,
                                        data: [1, 2, 3, 4, 5, 3, 2, 1],
                                    }
                                    ]
                                }
                            }
                            options={{
                                responsive: true,
                                plugins: {
                                    legend: {
                                        position: 'bottom',
                                    },
                                    title: {
                                        display: true,
                                        text: '日毎抽出数'
                                    }
                                }
                            }}
                        >


                        </Line>
                    </CardHeader>
                </Card>
                <Card className={styles.card}>
                    <CardHeader
                        header="ブランドごと検出数"
                    >
                    </CardHeader>
                </Card>
                <Card className={styles.card}>
                    <CardHeader header=
                        "ランクごと抽出数" >
                    </CardHeader>
                </Card>
            </div>
            <div className={styles.board}>

                <Card className={styles.card}>
                    <CardHeader>
                        更新件数推移
                    </CardHeader>
                </Card>
                <Card className={styles.card}>
                    <CardHeader>
                        未取得件数
                    </CardHeader>
                </Card>
                <Card className={styles.card}>
                    <CardHeader>
                        未検出件数
                    </CardHeader>
                </Card>
                <Card className={styles.card}>
                    <CardHeader>
                        未確認件数
                    </CardHeader>
                </Card>
            </div>
        </>

    );
}
export default Dashboard;